export default {"src":"/_next/static/media/conversation-1.129804ca.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};